<template>
    <RichText v-model="value.content" :options="optionsRichText" class="custom-richtext" />
</template>

<script>
import RichText from 'vcomponents/richtext/RichText.vue';
import CfMixin from 'mixins/CustomfieldsMixins';

export default {
    components: {
        RichText,
    },
    mixins: [CfMixin],

    data() {
        return {
            optionsRichText: [
                'Bold',
                'Italic',
                'Underline',
                'Strike',
                'BulletList',
                'OrderedList',
                'Divider',
                'Link',
                'Separator',
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.custom-richtext {
    width: 100%;
}
</style>
